var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$can('manage-collective-gateways', 'ipg-gateway'))?_c('main-content',[_c('gateway-form',{attrs:{"submit":_vm.createGateway,"psp":_vm.psp,"form_data":_vm.collective}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }